import { Component, OnInit, AfterViewInit } from '@angular/core';

declare var Swiper: any;
declare var $: any;

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit, AfterViewInit {
  constructor() { }

  ngOnInit(): void {
    // Set background videos
    if ($("[data-bg-video-src]").length > 0) {
      $("[data-bg-video-src]").each(function () {
        const src = $(this).attr("data-bg-video-src");
        // Create the video element
        const video = document.createElement("video");
        video.src = src;
        video.autoplay = true;
        video.loop = true;
        video.muted = true;
        video.playsInline = true;
        video.className = "bg-video";
        video.style.position = "absolute";
        video.style.top = "0";
        video.style.left = "0";
        video.style.width = "100%";
        video.style.height = "100%";
        video.style.objectFit = "cover";
        video.style.zIndex = "-1"; // Behind content
        video.style.pointerEvents = "none";
        // Append video to the container
        $(this).append(video);
        // Optional: remove the data attribute
        $(this).removeAttr("data-bg-video-src").addClass("background-video");
      });
    }
  }

  scrollDown(event: Event): void {
    event.preventDefault();
    window.scrollBy({
      top: 800,
      left: 0,
      behavior: 'smooth'
    });
  }

  ngAfterViewInit(): void {
    // Swiper for thumbnails
    const thumbsSwiper = new Swiper(".hero3Thumbs", {
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,
    });

    // Main Hero Swiper
    const mainSwiper = new Swiper('.hero-slider-3', {
      thumbs: {
        swiper: thumbsSwiper,
      },
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: function (number: number) {
          return number < 10 ? '0' + number : number.toString();
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });

    // Pause autoplay on hover
    document.addEventListener('mouseenter', (event: Event) => {
      const el = event.target;
      // Only run if el is an actual Element
      if (el instanceof Element && el.matches('.swiper-container')) {
        (el as any).swiper?.autoplay?.stop?.();
        el.classList.add('swiper-paused');

        const activeBullet = el.querySelector('.swiper-pagination-bullet-active') as HTMLElement;
        if (activeBullet) {
          activeBullet.style.animationPlayState = 'paused';
        }
      }
    }, true);

    // Resume autoplay on mouse leave
    document.addEventListener('mouseleave', (event: Event) => {
      const el = event.target;
      // Ensure el is a real HTML element before using .matches()
      if (el instanceof Element && el.matches('.swiper-container')) {
        (el as any).swiper?.autoplay?.start?.();
        el.classList.remove('swiper-paused');

        const activeBullet = el.querySelector('.swiper-pagination-bullet-active') as HTMLElement;
        if (activeBullet) {
          activeBullet.classList.remove('swiper-pagination-bullet-active');

          setTimeout(() => {
            activeBullet.classList.add('swiper-pagination-bullet-active');
          }, 10);
        }
      }
    }, true);
  }
}